// @ts-nocheck
import * as actions from '../../action-types';
import * as mutations from '../../mutation-types';
import axios from 'axios';
import utils from '@/app/utils/utils';
import { buildQuery } from '@/utils/url';

export default {
  [actions.GET_PRICE_PREDICTIONS]: ({ commit }, params) => {
    commit(mutations.SET_PRICE_PREDICTION_LOADING, true);

    return axios
      .get(`/api/pricing/predictions?${buildQuery(params)}`) // use /api/pricing/predictions/mock for testing
      .then((result) => {
        commit(mutations.SET_PRICE_PREDICTION_LOADING, false);
        commit(mutations.SET_PRICE_PREDICTION, result.data);
        return Promise.resolve();
      })
      .catch((error) => {
        commit(mutations.SET_PRICE_PREDICTION_LOADING, false);
        commit(mutations.SET_PRICE_PREDICTION_ERROR, error);
        return Promise.reject({ code: utils.getErrorCode(error) });
      });
  },
};
